<div
  class="container"
  [ngStyle]="{ transform: scale ? 'scale(' + scale + ')' : 'scale(0.5)' }"
>
  <span class="loader"></span>
</div>
